export const API_TIMEOUT = 10000;
export const EMPTY_STRING = '';

export const RESET_PASSWORD_URL = '/pkmslogout?REDIRECT=1';
export const ENROLL_URL = '/d3rest/v4/user/enroll';
export const THEME_URL = '/d3rest/v4/themes/WEB';
export const ATTRIBUTES_URL = '/d3rest/v4/user/enroll/attributes';



// WEBPACK FOOTER //
// ./src/Constants.ts